import Chart from "../../../../src/client/katnh/interactions/chart/Chart.js";
import OmzettenVKANaarDoac from "../../../../src/client/katnh/omzetten-vka-naar-doac.json";
import * as React from 'react';
export default {
  Chart,
  OmzettenVKANaarDoac,
  React
};